import Model, { attr, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import { service } from '@ember/service';
import JournalStageModel from './journal-stage';
import JournalGoalModel from './journal-goal';
import EmberArray from '@ember/array';

export default class JournalModel extends Model {
  @service declare formatDateService: any;

  @attr('string') name?: string;
  @attr('string') reportName?: string;
  @attr('date-only') declare startDate: Date;
  @attr('date-only') declare goalDate: Date;
  @attr('date-only') closedDate?: Date;
  @attr('boolean') declare decisionsRequireGift: boolean;
  @attr() declare contactIds: string[];
  @attr('string') campaignId?: string;

  @hasMany('journal-stage', { async: false, inverse: null })
  declare journalStages: EmberArray<JournalStageModel>;
  @hasMany('journal-goal', { async: false, inverse: null })
  declare journalGoals: EmberArray<JournalGoalModel>;

  @cached
  get contactIdsKeys() {
    let contactIdsKeys: { [contactId: string]: boolean } = {};
    this.contactIds?.forEach((id) => {
      contactIdsKeys[id] = true;
    });
    return contactIdsKeys;
  }

  @cached
  get label() {
    return isPresent(this.name)
      ? this.name
      : this.formatDateService.format(this.goalDate);
  }

  get active() {
    return this.closedDate == null || this.closedDate > new Date();
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    journal: JournalModel;
  }
}
